import styled from "styled-components";

export const StyledTitle = styled.h1`
  font-size: 1.5rem;
  color: rgb(var(--color-primary));
  font-weight: 700;
`;
